<template>
  <div class="avue-tags" v-if="showTag">
    <!-- tag盒子 -->
    <div
      v-if="contextmenuFlag"
      class="avue-tags__contentmenu"
      :style="{ left: contentmenuX + 'px', top: contentmenuY + 'px' }"
    >
      <div class="item" @click="closeOthersTags">关闭其他</div>
      <div class="item" @click="closeAllTags">关闭全部</div>
    </div>
    <div
      class="avue-tags__box"
      :class="{ 'avue-tags__box--close': !website.isFirstPage }"
    >
      <el-tabs
        v-model="active"
        type="card"
        @contextmenu.native="handleContextmenu"
        :closable="tagLen !== 1"
        @tab-click="openTag"
        @edit="menuTag"
      >
        <el-tab-pane
          :key="item.value"
          v-for="item in tagList"
          :label="item.label"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>
      <el-button
        type="primary"
        plain
        size="mini"
        icon="iconfont icon-caozuojiaocheng"
        class="actBtn"
        @click="openGuide"
      >
        操作教程
      </el-button>
      <el-dropdown class="avue-tags__menu">
        <el-button type="primary">
          更多
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="closeOthersTags">
            关闭其他
          </el-dropdown-item>
          <el-dropdown-item @click.native="closeAllTags">
            关闭全部
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 引导页 -->
    <guideIndex
      :visible.sync="showFirstGuide"
      @close-notice="closeNotice"
      @to-guide="toGuide"
    ></guideIndex>
    <stepGuide
      :visible.sync="showGuide"
      @close-notice="closeNotice"
    ></stepGuide>
    <guideConfirm :visible.sync="showConfrim"></guideConfirm>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import guideIndex from './guide/index';
import stepGuide from './guide/step';
import guideConfirm from './guide/confirm';
import './guide/index.scss';
export default {
  name: 'tags',
  components: { guideIndex, stepGuide, guideConfirm },
  data() {
    return {
      active: '',
      contentmenuX: '',
      contentmenuY: '',
      contextmenuFlag: false,
      showFirstGuide: false,
      showGuide: false,
      showConfrim: false,
    };
  },
  created() {},
  mounted() {
    let firstFlag = JSON.parse(sessionStorage.getItem('iol8cloud-userInfo'))
      ?.content.qcFirstLogin;
    if (firstFlag) {
      this.showFirstGuide = true;
    }
    this.setActive();
  },
  watch: {
    tag() {
      this.setActive();
    },
    contextmenuFlag(contextmenuShow) {
      // 只在右键菜单显示的时候监听鼠标点击事件
      if (contextmenuShow) {
        window.addEventListener('mousedown', this.watchContextmenu);
      }
    },
  },
  computed: {
    ...mapGetters(['tagWel', 'tagList', 'tag', 'website']),
    ...mapState({
      showTag: (state) => state.common.showTag,
      userInfo: (state) => state.user.userInfo,
    }),
    tagLen() {
      return this.tagList.length || 0;
    },
  },
  methods: {
    openGuide() {
      this.showGuide = true;
    },
    watchContextmenu(e) {
      if (!this.$el.contains(e.target)) {
        this.contextmenuFlag = false;
        window.removeEventListener('mousedown', this.watchContextmenu);
      }
    },
    handleContextmenu(event) {
      let target = event.target;
      // 解决 https://github.com/d2-projects/d2-admin/issues/54
      let flag = false;
      if (target.className.indexOf('el-tabs__item') > -1) flag = true;
      else if (target.parentNode.className.indexOf('el-tabs__item') > -1) {
        target = target.parentNode;
        flag = true;
      }
      if (flag) {
        event.preventDefault();
        event.stopPropagation();
        this.contentmenuX = event.clientX;
        this.contentmenuY = event.clientY;
        this.tagName = target.getAttribute('aria-controls').slice(5);
        this.contextmenuFlag = true;
      }
    },
    //激活当前选项
    setActive() {
      this.active = this.tag.value;
    },
    menuTag(value, action) {
      if (action === 'remove') {
        let { tag, key } = this.findTag(value);
        this.$store.commit('DEL_TAG', tag);
        if (tag.value === this.tag.value) {
          tag = this.tagList[key === 0 ? key : key - 1]; //如果关闭本标签让前推一个
          this.openTag(tag);
        }
      }
    },
    openTag(item) {
      let tag;
      if (item.name) {
        tag = this.findTag(item.name).tag;
      } else {
        tag = item;
      }
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: tag.label,
          src: tag.value,
        }),
        query: tag.query,
      });
    },
    closeOthersTags() {
      this.contextmenuFlag = false;
      this.$store.commit('DEL_TAG_OTHER');
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    closeAllTags() {
      this.contextmenuFlag = false;
      this.$store.commit('DEL_ALL_TAG');
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          src: this.tagWel.value,
        }),
        query: this.tagWel.query,
      });
    },
    closeNotice() {
      this.showFirstGuide = false;
      this.showGuide = false;
      this.showConfrim = true;
      let userInfo = JSON.parse(sessionStorage.getItem('iol8cloud-userInfo'));
      userInfo.content.qcFirstLogin = false;
      sessionStorage.setItem('iol8cloud-userInfo', JSON.stringify(userInfo));
    },
    toGuide() {
      this.showFirstGuide = false;
      this.showGuide = true;
      let userInfo = JSON.parse(sessionStorage.getItem('iol8cloud-userInfo'));
      userInfo.content.qcFirstLogin = false;
      sessionStorage.setItem('iol8cloud-userInfo', JSON.stringify(userInfo));
    },
  },
};
</script>
<style lang="scss" scope>
.actBtn {
  position: absolute;
  top: 4px;
  right: 92px;
}
</style>
